const HealthTypeEnum = Object.freeze({
    WEIGHT: { value: 0, text: 'Weight' },
    HEART_BEAT: { value: 1, text: 'Heart beat' },
    PRESSURE: { value: 2, text: 'Pressure' },
    IMAGE: { value: 3, text: 'Image' },
});

export default HealthTypeEnum;
